module.exports = __webpack_public_path__ + "static/media/TT.e3e1929d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/TT.svg
// module id = 2279
// module chunks = 7